import React from 'react';
import { useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';


function Sidebar({ isCollapsed, toggleSidebar, showContent, activePage }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await signOut(auth);
    navigate('/login');
  };

  const navItems = [
    { page: 'Dashboard', icon: 'tachometer-alt', label: 'Dashboard' },
    { page: 'Reports', icon: 'chart-bar', label: 'Reports & Analytics' },
    { page: 'SystemStatus', icon: 'cogs', label: 'System Status' },
    { page: 'Maintenance', icon: 'tools', label: 'Maintenance' },
    { page: 'Notifications', icon: 'bell', label: 'Notifications' },
    { page: 'KnowledgeTips', icon: 'book', label: 'Knowledge & Tips' },
  ];

  return (
    <div className={`sidebar ${isCollapsed ? 'collapsed' : ''}`}>
      
      {/* BRAND HEADER */}
      <div className="logo-toggle-container">
        <div className="sidebar-brand">
    <img
  src="/assets/logoa.png"
  alt="Olive AquaSense Logo"
  className="sidebar-product-logo"
/>

          {!isCollapsed && <span className="product-name">AquaSense</span>}
        </div>

        <button className="toggle-btn" onClick={toggleSidebar}>
          <i className="fas fa-bars"></i>
        </button>
      </div>

      {/* NAV */}
      <ul className="nav-links">
        {navItems.map((item) => (
          <li
            key={item.page}
            className={activePage === item.page ? 'active' : ''}
            onClick={() => showContent(item.page)}
          >
            <i className={`fas fa-${item.icon}`}></i>
            {!isCollapsed && <span className="nav-text">{item.label}</span>}
          </li>
        ))}
      </ul>

      {/* USER + LOGOUT */}
      <div className="user-section">
        <div className="user-profile">
          <div className="user-avatar">
            <i className="fas fa-user"></i>
          </div>
          {!isCollapsed && (
            <div className="user-info">
              <span className="user-name">Home User</span>
              <span className="user-role">System Manager</span>
            </div>
          )}
        </div>

        <div className="logout-btn" onClick={handleLogout}>
          <i className="fas fa-sign-out-alt"></i>
          {!isCollapsed && <span className="nav-text">Logout</span>}
        </div>
      </div>
    </div>
  );
}

export default Sidebar;
